import Vue from 'vue'
import App from './App.vue'
import router from './utilites/routers'
import store from './store'
// import './index.scss'
import Clipboard from 'v-clipboard'
import * as Sentry from "@sentry/vue";
import { Integrations } from '@sentry/tracing'
import components from '@/components/UI'
import VTooltip from 'v-tooltip'

if (process.env.VUE_APP_SENTRY) {
	Sentry.init({
		Vue,
		dsn: 'https://1528831dee3344ae9c4f99c1f51b6aea@o1276910.ingest.sentry.io/6474155',
		integrations: [
			new Integrations.BrowserTracing({
				routingInstrumentation: Sentry.vueRouterInstrumentation(router),
				tracingOrigins: ['dev-story.altezza.travel', 'altezza.travel', /^\//],
			}),
		],
		tracesSampleRate: 1.0,
		environment: process.env.VUE_APP_SENTRY
	})
}

import vSelect from 'vue-select'
import VueMask from 'v-mask'
import VueMeta from "vue-meta";
import i18n from './i18n'
components.forEach((component) => {
	Vue.component(component.name, component);
})
Vue.component('v-select', vSelect)
Vue.use(Clipboard)
Vue.use(VueMask);
Vue.use(VueMeta);
Vue.use(VTooltip, {
	defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click'
})

Vue.prototype.$setLocale = function (locale) {
	this.$i18n.locale = locale.toLowerCase();
};


Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
